import { Component, Input, TemplateRef, ViewContainerRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ContactItem, ContactDatasources, AdditionalContactDataTypes } from './models/contact-item';

@Component({
    selector: 'contact-item',
    templateUrl: './contact-item.component.html',
    styleUrls: ['./contact-item.component.scss'],
    standalone: false
})
export class ContactItemComponent {
    @ViewChild('portal', { read: ViewContainerRef, static: true })
    portal: ViewContainerRef;
    @ViewChild('context', { static: true })
    contextTemplate: TemplateRef<any>;
    @ViewChild('rule', { static: true })
    ruleTemplate: TemplateRef<any>;
    @ViewChild('activeUser', { static: true })
    activeUserTemplate: TemplateRef<any>;

    datasourceTypes = Object.values(ContactDatasources);
    additionalData = Object.keys(AdditionalContactDataTypes).filter(x => isNaN(x as any));
    selectedDataTypes: string[];
    _edit: boolean = true;
    _contact: ContactItem;

    @Input()
    contextObject: any;

    @Input()
    set contact(val: ContactItem) {
        this._contact = val;

        if (this._contact) {
            this.selectedDataTypes = [];
            let dataTypes = this._contact.dataType;

            if (dataTypes === AdditionalContactDataTypes.None) {
                this.selectedDataTypes.push(this.additionalData[AdditionalContactDataTypes.None]);
                return;
            }

            if (dataTypes & AdditionalContactDataTypes.Organization)
                this.selectedDataTypes.push(this.additionalData[AdditionalContactDataTypes.Organization]);
        }
    }

    get contact() {
        return this._contact;
    }

    @Input()
    set edit(val: boolean) {
        this._edit = val;

        if (!this._edit && this.portal)
            this.portal.clear();
        else
            this.setTemplate(this.contact.datasource);
    }

    get edit() { return this._edit; }

    constructor(
        public changeDetectorRef: ChangeDetectorRef
    ) { }

    onModelChange(event: ContactDatasources) {
        this.contact.datasource = event;
        this.contact.data = "";
        this.setTemplate(event);
    }

    selectAdditionalTypes(event: string[]) {
        this.contact.dataType = AdditionalContactDataTypes.None;

        event.forEach(x => {
            this.contact.dataType |= AdditionalContactDataTypes[x];
        });
    }

    toggleEdit() {
        this.setTemplate(this.contact.datasource);
    }

    setTemplate(type: ContactDatasources) {
        this.portal.clear();
        let template = this.activeUserTemplate;

        switch (type) {
            case ContactDatasources.ContextValue:
                template = this.contextTemplate;
                break;
            case ContactDatasources.Rule:
                template = this.ruleTemplate;
                break;
        }

        this.portal.createEmbeddedView(template);
    }
}
